import React from 'react';
import { observer } from 'mobx-react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Selector from '../../../common/Selector';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { GENERAL_LEDGER_CODE_TYPES_MAP } from '../../../../data';

const useStyles = makeStyles((theme) => ({
  buttonGroup: {
    '& > *': {
      marginLeft: theme.spacing(1),
    },
  },
}));

const Form = observer(({ generalLedgerCodeId, values, submit, loading, submitting, generalLedgerCodes }) => {
  const classes = useStyles();

  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    submit(e, generalLedgerCodeId).then((done) => {
      if (done) {
        history.goBack();
        generalLedgerCodes.loadGeneralLedgerCodes();
      }
    });
  }

  return <>
    <Box visibility={loading ? 'visible' : 'hidden'}><LinearProgress /></Box>
    <form onSubmit={handleSubmit}>
      <TextField
        label="CODE"
        name="code"
        margin="normal"
        value={values.code || ''}
        onChange={values.setAttributeByEvent}
        fullWidth
        required
      />
      <FormControl fullWidth required>
        <InputLabel id="typeSelector">TYPE</InputLabel>
        <Select labelId="typeSelector" name="type" value={values.type || 0} onChange={values.setAttributeByEvent} fullWidth required >
          {Object.keys(GENERAL_LEDGER_CODE_TYPES_MAP).map((type) =>
            <MenuItem value={GENERAL_LEDGER_CODE_TYPES_MAP[type]}>{type}</MenuItem>
          )}
        </Select>
      </FormControl>
      <TextField
        label="NAME"
        name="name"
        margin="normal"
        value={values.name || ''}
        onChange={values.setAttributeByEvent}
        fullWidth
        required
      />
      <TextField
        label="DESCRIPTION"
        name="description"
        margin="normal"
        multiline
        rows={3}
        value={values.description || ''}
        onChange={values.setAttributeByEvent}
        fullWidth
        required
      />
      <Box mt={2} display="flex" flexDirection="row-reverse" className={classes.buttonGroup}>
        <Button
          variant="contained"
          disabled={submitting}
          onClick={history.goBack}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={submitting}
        >
          Save
      </Button>
      </Box>
    </form>
  </>
})

export default Form;

Form.propTypes = {
}
